import { B, BadgeDot, badgeStyle, type Tint } from "../../design/tokens";

const MAP: Record<string, { c: Tint; label: string }> = {
  // canonical statuses
  active: { c: B.tints.mint, label: "Active" },
  closed: { c: B.tints.sand, label: "Closed" },
  draft: { c: B.tints.butter, label: "Draft" },
  scheduled: { c: B.tints.sky, label: "Scheduled" },
  archived: { c: B.tints.sand, label: "Archived" },
  // receipt statuses
  pending: { c: B.tints.butter, label: "Needs review" },
  error: { c: B.tints.rose, label: "Error" },
  reviewed: { c: B.tints.mint, label: "Reviewed" },
  // receipt types
  receipt: { c: B.tints.sky, label: "Receipt" },
  bill: { c: B.tints.peach, label: "Bill" },
  income: { c: B.tints.mint, label: "Income" },
};

export default function StatusPill({ status, label }: { status: string; label?: string }) {
  const m = MAP[status] ?? MAP.draft;
  return (
    <span style={badgeStyle(m.c)}>
      <BadgeDot c={m.c} />
      {label ?? m.label}
    </span>
  );
}
